import {
  SOLANA_SYSTEM_PROGRAM_ID,
  decodeSolanaCommitmentRecord,
  type SolanaAccountInfo,
} from "@stealthos/sdk";
import { fail } from "./common";

/** Match the program's PDA allocation rules, including third-party prefunding. */
export function solanaPoolAccountExists(
  account: SolanaAccountInfo | null,
  programId: string,
  kind: "nullifier" | "commitment",
): boolean {
  if (!account) return false;
  if (account.executable) fail(`invalid ${kind} account: executable`);
  if (account.owner === SOLANA_SYSTEM_PROGRAM_ID && account.data.length === 0)
    return false;
  if (account.owner !== programId) fail(`invalid ${kind} account owner`);
  if (kind === "commitment") decodeSolanaCommitmentRecord(account.data);
  else if (account.data.length !== 0) fail("invalid nullifier account data");
  return true;
}
